import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useQuery } from 'react-query';
import {
  downloadPersonnelAdjustmentDocxFile,
  downloadPersonnelAdjustmentPdfFile,
} from 'apis/personnelAdjustment.api';
import { autoDownloadFile } from 'utils/func';

// eslint-disable-next-line no-unused-vars
export default function DownloadPersonnelAdjustmentFile({ id, projectId }) {
  const { t } = useTranslation();

  const {
    refetch: handleDownloadPdfFile,
    isLoading: isDownloadPdfFileLoading,
    isFetching: isDownloadPdfFileFetching,
  } = useQuery(
    ['downloadPersonnelAdjustmentPdfFile', id],
    () => downloadPersonnelAdjustmentPdfFile(id),
    {
      enabled: false,
      onSuccess: (res) => {
        autoDownloadFile(res);
      },
    }
  );

  const {
    refetch: handleDownloadDocxFile,
    isLoading: isDownloadDocxFileLoading,
    isFetching: isDownloadDocxFileFetching,
  } = useQuery(
    ['downloadPersonnelAdjustmentDocxFile', id],
    () => downloadPersonnelAdjustmentDocxFile(id),
    {
      enabled: false,
      onSuccess: (res) => {
        autoDownloadFile(res);
      },
    }
  );

  return (
    <div className="flex justify-content-end gap-2 mr-5 mt-5">
      <Button
        type="button"
        label={t('projectProposal.review.exportDocx')}
        icon={`pi ${
          isDownloadDocxFileLoading || isDownloadDocxFileFetching
            ? 'pi-spin pi-spinner'
            : 'pi-file-word'
        }`}
        className="block w-auto h-3rem mr-4"
        severity="info"
        onClick={handleDownloadDocxFile}
        disabled={!id || isDownloadDocxFileLoading || isDownloadDocxFileFetching}
      />
      <Button
        type="button"
        label={t('projectProposal.review.exportPdf')}
        icon={`pi ${
          isDownloadPdfFileLoading || isDownloadPdfFileFetching
            ? 'pi-spin pi-spinner'
            : 'pi-file-pdf'
        }`}
        className="block w-auto h-3rem border-none"
        style={{ backgroundColor: 'var(--red-400)' }}
        onClick={handleDownloadPdfFile}
        disabled={!id || isDownloadPdfFileLoading || isDownloadPdfFileFetching}
      />
    </div>
  );
}

DownloadPersonnelAdjustmentFile.propTypes = {
  id: PropTypes.string,
  projectId: PropTypes.string,
};

DownloadPersonnelAdjustmentFile.defaultProps = {
  id: undefined,
  projectId: '',
};
